import styled from 'styled-components';
import green from 'sushiweb/tokens/color/green';

export const PageWrapper = styled.div`
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
`;

export const LoadingContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;

  h2 {
    font-size: 1.5rem;
    color: #2c3e50;
    margin-bottom: 0.5rem;
  }

  p {
    color: #6c757d;
    font-size: 1rem;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100dvh;
  background: #ffffff;
  position: relative;
  overflow: hidden;

  @media (min-width: 768px) {
    width: 480px;
    margin: 0 auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    height: 100vh;
  }
`;

export const Header = styled.div`
  position: relative;
  overflow: hidden;
`;

export const HeaderGradient = styled.div`
  background: linear-gradient(
    135deg,
    #7293f3 0%,
    #7b3ff2 20%,
    #e23744 40%,
    #f8b301 50%,
    #e23744 60%,
    #7b3ff2 80%,
    #4a72e2 100%
  );
  background-size: 300% 300%;
  animation: gradientShift 8s ease infinite;
  padding: 7rem 1.5rem 1rem;
  text-align: center;
  position: relative;

  @keyframes gradientShift {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -10%;
    width: 200px;
    height: 200px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    animation: float 10s ease-in-out infinite;
  }

  @keyframes float {
    0%,
    100% {
      transform: translate(0, 0);
    }
    50% {
      transform: translate(-20px, 20px);
    }
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -30%;
    left: -5%;
    width: 150px;
    height: 150px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
    animation: float 8s ease-in-out infinite reverse;
  }
`;

export const HeaderLogo = styled.img`
  position: absolute;
  top: 2rem;
  left: 1.5rem;

  width: 80px;
  z-index: 2;
`;

export const HeaderTitle = styled.h1`
  color: #ffffffff;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  position: relative;
  z-index: 1;

  @media (min-width: 768px) {
    font-size: 2.3 rem;
  }
`;

export const HeaderSubtitle = styled.p`
  color: rgba(255, 255, 255, 0.95);
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 2px;
  margin: 0;
  position: relative;
  z-index: 1;

  @media (min-width: 768px) {
    font-size: 0.85rem;
  }
`;

export const Content = styled.div`
  flex: 1;
  padding: 1.5rem;
  overflow: hidden;
  min-height: 0;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    padding: 2rem;
  }
`;

export const LoadingContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: left;
  margin: 0 0 1.5rem 0;
  gap: 0.75rem;
`;

export const LogoBox = styled.div`
  width: 50px;
  height: 50px;
  background: ${props => props.bgColor || '#f39c12'};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.9rem;
  color: #ffffff;
  text-transform: lowercase;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  @media (min-width: 768px) {
    width: 50px;
    height: 50px;
    font-size: 1rem;
  }
`;

export const Title = styled.div`
  font-size: 1.7rem;
  margin: 0 0 1rem 0;
  line-height: 1.4;
  text-align: left;
  font-family: 'Lexend-400';

  @media (min-width: 768px) {
    font-size: 2rem;
    margin: 0 0 1rem 0;
  }
`;

export const Subtitle = styled.div`
  font-size: 1.5rem;
  font-family: 'Lexend-400';
  margin: 1rem 0 1rem 0;
  line-height: 1.2;

  @media (min-width: 768px) {
    font-size: 1.8rem;
  }

  strong {
    font-family: 'Lexend-400';
  }
`;

export const SectionTitle = styled.div`
  font-size: 1.5rem;
  font-family: 'Lexend-400';
  margin: 1rem 0 2rem 0;
  line-height: 1.2;

  span {
    font-family: Lexend-700;
    font-weight: 800;
  }
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
`;

// Updated OptionCard to use justify-between
export const OptionCard = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between; /* Space between left content and logo */
  padding: 0.8rem 1rem;
  border: 2px solid ${props => (props.selected ? '#4A72E2' : '#edededff')};
  border-radius: 12px;
  background: ${props => (props.selected ? '#dde5faff' : '#ffffff')};
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;

  &:hover {
    border-color: ${props => (props.selected ? '#4A72E2' : '#bdbdbd')};
    background: ${props => (props.selected ? '#dde5faff' : '#fafafa')};
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const OptionContent = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const MultipleLogosContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const OptionLogoContainer = styled.div`
  width: ${props => (props.isMultiple ? '32px' : '32px')};
  height: ${props => (props.isMultiple ? '32px' : '32px')};
  border-radius: 50%;
  background: ${props => props.bgColor || '#f39c12'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

export const OptionLogo = styled.img`
  width: ${props => (props.isMultiple ? '24px' : '24px')};
  height: ${props => (props.isMultiple ? '24px' : '24px')};
  object-fit: contain;
`;

export const ModalContent = styled.div`
  text-align: center;
  padding: 1rem;
`;

export const ModalTitle = styled.div`
  font-size: 2rem;
  font-family: 'Lexend-400';
  margin: 0.7rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
`;

export const ModalText = styled.div`
  font-size: 1.5rem;
  color: #6c757d;
  line-height: 1.5;
  margin-bottom: 1rem;
  font-family: 'Lexend-300';

  strong {
    color: #2c3e50;
    font-family: 'Lexend-400';
  }
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;

  flex-direction: column;
  gap: 0.75rem;

  button {
    width: 100%;
    margin-right: 0 !important;
  }
`;

export const RadioCircle = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid ${props => (props.selected ? '#4A72E2' : '#bdbdbd')};
  border-radius: 50%;
  margin-right: 1rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
`;

export const RadioInner = styled.div`
  width: 10px;
  height: 10px;
  background: #4a72e2;
  border-radius: 50%;
`;

export const OptionLabel = styled.span`
  font-size: 1.5rem;
  color: #2c3e50;
  font-family: 'Lexend-400';

  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const VoucherCard = styled.div`
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 1.25rem;
  margin: 1rem 0;
`;

export const VoucherLabel = styled.p`
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 0.5rem 0;
`;

export const VoucherValue = styled.p`
  font-size: 1.5rem;
  font-family: 'Lexend-400';
  margin: 0;
  letter-spacing: 0.5px;

  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const InfoSection = styled.div`
  padding: 1rem;
  border-radius: 8px;
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.75rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoText = styled.span`
  font-size: 1.5rem;
  font-family: 'Lexend-300';
  line-height: 1.5;
`;

export const SpinnerContainer = styled.div`
  margin-bottom: 1.5rem;
`;

export const LoadingTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 0.5rem 0;
  text-align: center;
`;

export const LoadingSubtitle = styled.p`
  font-size: 0.9rem;
  color: #6c757d;
  margin: 0;
  text-align: center;
`;

export const PrimaryButton = styled.button`
  background: ${props => (props.disabled ? '#bdbdbd' : '#4A72E2')} !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 1rem 2rem !important;
  font-size: 1.8rem !important;
  font-family: 'Lexend-300', sans-serif !important;
  font-weight: 600 !important;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')} !important;
  transition: all 0.2s ease !important;
  width: 100% !important;
  opacity: ${props => (props.disabled ? 0.6 : 1)} !important;

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 0.5rem !important;

  .button-icon {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    padding: 0 5px;

    ${props =>
      props.iconAlign === 'left' &&
      `
      order: -1;
    `}

    ${props =>
      props.iconAlign === 'right' &&
      `
      order: 1;
    `}
  }

  &:hover {
    background: ${props => (props.disabled ? '#bdbdbd' : '#5a7bd6')} !important;
  }

  &:active {
    background: ${props => (props.disabled ? '#bdbdbd' : '#4a6bc4')} !important;
  }
`;

export const Footer = styled.div`
  padding: 1rem 1.5rem;
  background: #ffffff;
  border-top: 1px solid #e9ecef;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  margin-top: auto;
  position: sticky;
  bottom: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;

  @supports not (height: 100dvh) {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 480px;
  }

  @media (min-width: 768px) {
    padding: 1.25rem 2rem;
    position: relative;
    bottom: auto;
    left: auto;
    transform: none;
    width: auto;
    max-width: none;
  }
`;

export const VoucherRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;

export const CopyButton = styled.button`
  background: ${props => (props.copied ? green.z500 : '#4A72E2')};
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 60px;
  white-space: nowrap;

  &:hover {
    background: ${props => (props.copied ? green.z600 : '#4A72E2')};
  }
`;
